/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Cart } from '@/models';
import {
  LOAD_CART_ACTION,
  SET_CART_ITEM_QUANTITY_ACTION,
} from '@/store';

const cartStore = namespace('cart');

@Component
export default class CartView extends Vue {
  @cartStore.State('cart') public cart?: Cart;
  @cartStore.Action(SET_CART_ITEM_QUANTITY_ACTION) public setItemQuantity: any;
  @cartStore.Action(LOAD_CART_ACTION) private loadCart: any;

  get isEmptyCart() {
    return !this.cart || (this.cart.items.length === 0);
  }

  public created() {
    this.loadCart();
  }
}
